import { useRouter } from 'react-resource-router';

import { RouteContext } from 'src/router/routes/types';

import { DefaultSideNav } from './default';

export const SideNav = (): JSX.Element => {
  const [routerState] = useRouter();
  const { route } = routerState as RouteContext;
  const RouteNavigation = route.sideNavigation;

  return RouteNavigation ? <RouteNavigation /> : <DefaultSideNav />;
};
